<form [formGroup]="form">
    <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form"></formly-form>
</form>

